<template>
  <div class="relative bg-gray-900 rounded-xl p-4 mt-4 text-sm text-white"
       :class="{'border-2 border-green-500' : factor.irani_Service_Code === 3 || factor.farangi_Service_Code === 3}"
       @click="selectFactor" @touchstart="toggleAnimation($event)" @touchend="toggleAnimation">
    <div class="grid grid-cols-2">
      <span class="flex">
        <UserIcon class="w-5 h-5 text-yellow-300"/>
        <span class="mr-1">{{ factor.name_Client }}</span>
      </span>
      <span class="flex items-center">
        <UserGroupIcon class="h-5 w-5 text-yellow-300"/>
        <span class="mr-1">{{ factor.tedad }} نفر</span>
      </span>
    </div>
    <div class="grid grid-cols-2 mt-3">
      <span class="flex">
          <LocationMarkerIcon class="h-5 w-5 text-yellow-300"/>
          <span class="mr-1">{{ factor.namE_SALON }}</span>
      </span>
      <span class="flex">
        <TableIcon class="h-5 w-5 text-yellow-300"/>
        <span class="mr-1">میز {{ factor.shO_TABLE }}</span>
      </span>
    </div>
    <div class="grid grid-cols-2 mt-3">
      <span class="flex">
        <CreditCardIcon class="h-5 w-5 text-yellow-300"/>
        <span class="mr-1" :class="renderPaymentType()">{{ factor.pardakhT_STATUS }}</span>
      </span>
      <span class="flex">
        <ClockIcon class="h-5 w-5 text-yellow-300"/>
        <span class="mr-1">{{ factor.timE_FACTOR + ' ' + factor.datE_FACTOR }}</span>
      </span>
    </div>
    <hr class="my-2">

    <div class="grid grid-cols-4 text-gray-500 text-center text-xs">
      <span @click.stop="toggleStatusDialog('farangI_STATUS_Code')"
            @touchstart.stop @touchend.stop>فرنگی</span>
      <span @click.stop="toggleStatusDialog('iranI_STATUS_CODE')"
            @touchstart.stop @touchend.stop>ایرانی</span>

      <span @touchstart.stop @touchend.stop>سرویس ایرانی</span>
      <span @touchstart.stop @touchend.stop>سرویس فرنگی</span>
    </div>

    <div class="grid grid-cols-4 mt-2 text-xs">
      <span class="flex justify-center">
          <span class="mr-1" @click.stop="toggleStatusDialog('farangI_STATUS_Code')"
                @touchstart.stop @touchend.stop>{{ factor.farangI_STATUS }}</span>
        </span>
      <span class="flex justify-center">
        <span class="mr-1" @click.stop="toggleStatusDialog('iranI_STATUS_CODE')"
              @touchstart.stop @touchend.stop>{{ factor.iranI_STATUS }}</span>
      </span>

      <span class="flex justify-center">
        <span class="mr-1" @touchstart.stop @touchend.stop>{{ factor.irani_Service }}</span>
      </span>

      <span class="flex justify-center">
        <span class="mr-1" @touchstart.stop @touchend.stop>{{ factor.farangi_Service }}</span>
      </span>
    </div>

    <div class="grid grid-cols-2 mt-2" v-if="showDeliveryButtons()">
      <button class="bg-green-500 w-3/4 mx-auto py-2 text-xs rounded-lg disabled:bg-green-500/10"
              @click.stop="foodDelivered(1)"
              :disabled="!(factor.farangI_STATUS_Code === 2 || (factor.farangI_STATUS_Code === 3 && factor.confirm_Delivery_Farangi === 0))">
        تحویل
      </button>
      <button class="bg-green-500 w-3/4 mx-auto py-2 text-xs rounded-lg disabled:bg-green-500/10"
              @click.stop="foodDelivered(0)"
              :disabled="!(factor.iranI_STATUS_CODE === 2 || (factor.iranI_STATUS_CODE === 3 && factor.confirm_Delivery_Irani === 0))">
        تحویل
      </button>
    </div>

    <div class="absolute top-0 left-0 text-red-500 ml-2 mt-2" v-if="factor.prinT_Type === 'NoPrint'">
      <PrinterIcon class="h-7 w-7"/>
    </div>
  </div>

  <transition name="fade">
    <div class="fixed flex items-center w-full h-screen bg-gray-500 bg-opacity-50 top-0 right-0 z-20"
         v-if="statusDialog" @click.stop="toggleStatusDialog('')">
      <div class="bg-gray-800 -mt-16 w-2/3 h-2/3 mx-auto rounded-xl text-center text-white leading-10">
        <h1>وضعیت</h1>
        <hr class="my-2">
        <h2 :class="renderStatus(-1)">فاقد چاپ</h2>
        <ArrowDownIcon class="h-5 w-5 mx-auto"/>
        <h2 :class="renderStatus(0)">در صف انتظار</h2>
        <ArrowDownIcon class="h-5 w-5 mx-auto"/>
        <h2 :class="renderStatus(1)">در حال آماده سازی</h2>
        <ArrowDownIcon class="h-5 w-5 mx-auto"/>
        <h2 :class="renderStatus(2)">آماده تحویل</h2>
        <ArrowDownIcon class="h-5 w-5 mx-auto"/>
        <h2 :class="renderStatus(3)">تحویل شده</h2>
      </div>
    </div>
  </transition>

</template>

<script>
import {
  ArrowDownIcon,
  ClockIcon,
  CreditCardIcon,
  LocationMarkerIcon,
  PrinterIcon,
  TableIcon,
  UserGroupIcon,
  UserIcon
} from '@heroicons/vue/outline'
import {getFactorById} from "@/API/API";
import {postFoodDelivered} from "../API/API";

export default {
  name: "FactorCard",
  components: {
    UserIcon,
    ClockIcon,
    TableIcon,
    UserGroupIcon,
    CreditCardIcon,
    LocationMarkerIcon,
    PrinterIcon,
    ArrowDownIcon
  },
  props: ['factor'],
  emits: ['refresh'],
  data() {
    return {
      statusDialog: false,
      statusType: ''
    }
  },
  methods: {
    selectFactor() {
      if(!this.$loading.value) {
        getFactorById(this.factor.factoR_ID)
            .then(resp => {
              this.$store.dispatch('editCart', resp.data.result.goods)
              delete resp.data.result.goods
              this.$store.dispatch('editFactor', resp.data.result)
              this.$router.push('/submit-order')
            })
            .catch(() => {
              this.$swal({
                icon: 'error',
                title: 'خطا',
                text: 'فاکتوری پیدا نشد.',
                confirmButtonColor: '#fcd34d',
                confirmButtonText: 'باشه'
              })
            })
      }
    },
    toggleAnimation(event) {
      if (!this.$loading.value) {
        event.currentTarget.classList.toggle('border-yellow-500')
        event.currentTarget.classList.toggle('border')
      }
    },
    renderPaymentType() {
      switch (this.factor.pardakhT_TYPE) {
        case 'NoPaid':
          return 'text-red-500'
        case 'Paid':
          return 'text-green-500'
        case 'Remain':
          return 'text-yellow-500'
      }
    },
    toggleStatusDialog(type) {
      if (this.factor[type] !== -2) {
        this.statusDialog = !this.statusDialog
        this.statusType = type
      }
    },
    renderStatus(status) {
      if (status < this.factor[this.statusType]) {
        return "text-green-500"
      } else if (status === this.factor[this.statusType]) {
        return "bg-yellow-500"
      }
    },
    foodDelivered(foodKind) {
      postFoodDelivered(this.factor.factoR_ID, foodKind)
          .then(resp => {
            this.$swal({
              icon: 'success',
              title: 'موفق',
              text: resp.data.result,
              confirmButtonColor: '#fcd34d',
              confirmButtonText: 'باشه'
            })
            this.$emit('refresh')
          })
    },
    showDeliveryButtons() {
      if (this.factor.farangI_STATUS_Code === 2 || this.factor.iranI_STATUS_CODE === 2) {
        return true
      } else if ((this.factor.iranI_STATUS_CODE === 3 && this.factor.confirm_Delivery_Irani === 0) || (this.factor.farangI_STATUS_Code === 3 && this.factor.confirm_Delivery_Farangi === 0)) {
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease-in-out;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>